import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const csmReportsSatisfaction2Route: InvariantJiraRoute = {
	name: 'csm-reports-satisfaction',
	path: '/jira/customer-service-management/projects/:projectKey/reports/all-rating',
};
